import { render, staticRenderFns } from "./MyDic.vue?vue&type=template&id=700c747c&scoped=true"
import script from "./MyDic.vue?vue&type=script&lang=js"
export * from "./MyDic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700c747c",
  null
  
)

export default component.exports